import Swiper, { Navigation } from "swiper";

const SingleService = {
  init() {
    SingleService.stepsSlider();
  },

  stepsSlider() {
    const stepsEl = $(".service-steps");
    if (stepsEl.length) {
      new Swiper(stepsEl.find(".swiper")[0], {
        modules: [Navigation],
        slidesPerView: "auto",

        navigation: {
          prevEl: stepsEl.find(".swiper-button-prev")[0],
          nextEl: stepsEl.find(".swiper-button-next")[0],
        },
      });
    }
  }

};

export default SingleService;
